import clsx from 'clsx';
import type { LabelHTMLAttributes } from 'react';

export interface FormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  description?: string;
  layout?: 'horizontal' | `horizontal-${string}` | 'vertical';
  required?: boolean;
  hideRequiredStar?: boolean;
}

export const FormLabel = ({
  id,
  description,
  layout = 'horizontal',
  required,
  className,
  children,
  hideRequiredStar = !required,
  ...rest
}: FormLabelProps) => {
  return (
    <label
      {...rest}
      htmlFor={id}
      className={clsx(
        'text-b3 font-semibold text-black flex',
        {
          'ps-20': layout.includes('horizontal') && !layout.includes('no-padding'),
          'flex-wrap items-center': layout.includes('horizontal'),
          'flex-col items-start': layout.includes('vertical'),
        },
        className,
      )}
      data-name="InputLabel"
    >
      {children}
      {required && !hideRequiredStar && <span>*</span>}
      {description && <span className="ms-12 text-b4 text-grey font-normal">{description}</span>}
    </label>
  );
};
